/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Transcript_ImportInputs */



/**
* | output |
* | --- |
* | "AI Transcript Import" |
*
* @param {Ai_Transcript_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_transcript_import = /** @type {((inputs?: Ai_Transcript_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Transcript_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de transcription IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("KI-Transkriptimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione di trascrizioni AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт расшифровки ИИ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de transcripciones mediante IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AI转录导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIトランスクリプトインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई ट्रांसक्रिप्ट आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de transcrição por IA")
	return /** @type {LocalizedString} */ ("AI Transcript Import")
});